export class DPCGRenderer {
	canvas: HTMLCanvasElement
	gl: WebGL2RenderingContext
	constructor(canvas?: HTMLCanvasElement) {
		this.canvas = canvas || document.createElement("canvas")
		let gl = this.canvas.getContext('webgl2', {
			// alpha: true,
			antialias: true,
			// depth: true,
			// desynchronized: true,
			// failIfMajorPerformanceCaveat: false,
			// powerPreference: "default",
			// premultipliedAlpha: true,
			preserveDrawingBuffer: true,
			// xrCompatible: false
		})
		if(gl == null) throw "webgl2 could not be initialized"
		this.gl = gl
		this.gl.getExtension('OES_texture_float_linear')
		this.gl.getExtension('EXT_color_buffer_float')
		// this.gl.clearColor(0, 0, 0, 0)
		// console.log(gl.getContextAttributes())
	}
}
